import styled from 'styled-components';

const List = styled.ul`
  margin: 0;
  padding: 0;
`;

export default List;


// WEBPACK FOOTER //
// ./src/components/SocialMedia/List.js